<template>
  <div class="news_detail" v-html="detail.content">
  </div>
</template>
<script>
	import { getCommunityResponsDetail } from "@/api/hjy";
	export default {
	  name: "NewsDetail",
	  data(){
	        return {
	            detail:{content:''},//详情
	        }
	   },
	   methods: {
				getCommunityResponsDetail(){
					getCommunityResponsDetail({
							id:this.$route.query.id
						})
						.then(res => this.detail = res.data);
				},
			},
			mounted(){
				this.getCommunityResponsDetail();
			}
	};
</script>
<style lang="stylus">
.news_detail
    line-height 30px
    h3
        margin 50px 0
        font-size 36px
        color #1278C6
        text-align center
    img
        margin 30px auto
        display block
    .nd_guide
        margin-top 97px
        color #222222
        dd:hover
            color #1278c6
</style>